import { FC, useContext } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import useToggle from "../../hooks/useToggle";
import { useI18n } from "../../hooks/useTranslations";
import useProcessingRequestApi from "../../http/processingRequest/api";
import {
  ProcessingRequest,
  ProcessingRequestStatus,
  ProcessingRequestStatuses,
} from "../../http/processingRequest/types";
import Box from "../ui/Box";
import Button from "../ui/Button";
import Sidebar from "../ui/Sidebar";
import RequestRecap from "./RequestRecap";
import UpdateRequestStatusForm, { UpdateRequestStatusFormBody } from "./UpdateRequestStatusForm";
import styles from "./UpdateStatusButton.module.css";

interface UpdateStatusButton {
  title: string;
  newStatus: ProcessingRequestStatus;
  request: ProcessingRequest;
  totalUsedProductsCost?: number;
  onUpdate: () => void;
}

const UpdateStatusButton: FC<UpdateStatusButton> = ({ newStatus, onUpdate, title, request, totalUsedProductsCost }) => {
  const { isOpen, close, open } = useToggle();
  const i18n = useI18n();
  // const processingRequestHistoryApi = useProcessingRequestHistoryApi();
  const processingRequestApi = useProcessingRequestApi();
  const dispatch = useContext(NotificationDispatch);

  const onSubmit = async (formData: UpdateRequestStatusFormBody) => {
    try {
      newStatus == ProcessingRequestStatuses.Accepted &&
        (await processingRequestApi.takeInChargeRequest({ notes: formData.notes }, request.id));

      newStatus == ProcessingRequestStatuses.WaitingConfirmation &&
        (await processingRequestApi.sendOfferRequest({ notes: formData.notes }, request.id));

      newStatus == ProcessingRequestStatuses.OfferApproved &&
        (await processingRequestApi.acceptRequest({ notes: formData.notes }, request.id));

      newStatus == ProcessingRequestStatuses.Refused &&
        (await processingRequestApi.refuseRequest({ notes: formData.notes }, request.id));

      newStatus == ProcessingRequestStatuses.Discarded &&
        (await processingRequestApi.discardRequest({ notes: formData.notes }, request.id));

      newStatus == ProcessingRequestStatuses.InProgress &&
        (await processingRequestApi.startRequest({ notes: formData.notes }, request.id));

      newStatus == ProcessingRequestStatuses.Closed &&
        (await processingRequestApi.finishRequest({ notes: formData.notes }, request.id));

      onUpdate();
      close();
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    }
  };

  return (
    <>
      <Button
        buttonProps={{
          className: styles.buttonSpace,
          onClick: open,
        }}
      >
        {title}
      </Button>
      <Sidebar isOpen={isOpen} onClose={close} title={i18n.t.notes.addNote}>
        {request && totalUsedProductsCost && (
          <div className={styles.gap}>
            <Box title={i18n.t.processingRequests.requestRecap}>
              <RequestRecap request={request!} totalUsedProductsCost={totalUsedProductsCost!}></RequestRecap>
            </Box>
          </div>
        )}
        <UpdateRequestStatusForm isSidebarOpen={isOpen} onSubmit={onSubmit}></UpdateRequestStatusForm>
      </Sidebar>
    </>
  );
};

export default UpdateStatusButton;
